import type { FleetId, ResourceId, UserId } from '../types';

/**
 * O balde de memória do Cobli IA (página /ai e sidepanel).
 *
 * Existe porque o prefixo já divergiu uma vez: ele entrou no chat (#10940) e a lista de conversas
 * continuou no balde sem prefixo, o do painel flutuante. A lista mostrava conversas de outra
 * superfície, e responder numa delas caía no guarda de dono do `ai` (`isThreadOwnedByRequest`) —
 * a rota trocava o thread e o assistente respondia sem memória do que estava na tela.
 *
 * Com o prefixo num lugar só, chat e lista não têm como apontar para baldes diferentes.
 *
 * Os parâmetros aceitam indefinido de propósito: o `useThreads` desabilita a busca quando o
 * `resourceId` contém "undefined", e é assim que a lista não dispara antes da sessão carregar.
 */
export const assistantResourceId = (userId: UserId | undefined, fleetId: FleetId | undefined): ResourceId => `assistant_${userId}_${fleetId}` as ResourceId;
